module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consulta-por-cpf column",
    attrs: {
      "id": "consulta-por-cpf-para-mcmv-cidades"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "formulario u-margem-pequena"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-esquerda-pequena"
  }, [_vm._v("\n        Informe o CPF do pretendente para solicitar o subsídio para o projeto\n        " + _vm._s(_vm.projeto.Nome) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [(_vm.deveExibirAlerta) ? _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "formulario"
  }, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna campos-numericos-medio"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpf),
      expression: "cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }],
    attrs: {
      "id": "cpf",
      "type": "text",
      "placeholder": "Insira somente números do CPF"
    },
    domProps: {
      "value": (_vm.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpf = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4 u-margem-superior-grande"
  }, [(true) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio u-sem-margem-superior",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.obterProtocoloPorCpf
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Adicionar\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_5"
  }, _vm._l((_vm.proponentes), function(proponente) {
    return _c('h5', {
      staticClass: "titulo titulo_cor-terciaria"
    }, [_vm._v("\n                " + _vm._s(proponente.Nome) + "\n                " + _vm._s(proponente.Conjuge ? (", " + (proponente.Conjuge.Nome)) : "") + "\n                "), (true) ? _c('button', {
      staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removerProponente(proponente)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna campos-numericos-medio"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "renda-familiar-comprovada"
    }
  }, [_vm._v("Renda Familiar comprovada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.dadosParaValidacaoDaRendaFamiliarComprovada.RendaFamiliar
      ),
      expression: "\n              dadosParaValidacaoDaRendaFamiliarComprovada.RendaFamiliar\n            "
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input u-margem-inferior-pequena",
    attrs: {
      "name": "renda-familiar-comprovada",
      "type": "text",
      "id": "renda-familiar-comprovada",
      "placeholder": "Insira a renda familiar",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.dadosParaValidacaoDaRendaFamiliarComprovada.RendaFamiliar
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosParaValidacaoDaRendaFamiliarComprovada, "RendaFamiliar", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cinza u-margem-direita-media",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.retornarParaSelecaoDeProjetos
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-terciaria u-margem-superior-media",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.preencheuRenda || !_vm.possuiProponentes
    },
    on: {
      "click": _vm.validarRendaFamiliarComprovada
    }
  }, [_vm._v("\n            Avançar\n          ")])])])])], 1), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemFlutuante.mensagemVisivel,
      "titulo": _vm.mensagemFlutuante.tituloMensagem,
      "estilo": _vm.mensagemFlutuante.estiloMensagem,
      "texto": _vm.mensagemFlutuante.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f602366", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f602366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacao-de-subsidio/McmvCidades/ConsultaPorCpfParaMcmvCidades.vue
// module id = 1126
// module chunks = 1